import React from 'react';
import PropTypes from 'prop-types';
import EventCard from './EventCard';
import './EventListGrid.css';
import { buildDeepLink, shareDeepLink } from '../../utils/deepLink';

/**
 * Event List Grid component
 * Displays a responsive grid of event cards
 */
const EventListGrid = ({ events, loading, onShare }) => {
    const handleShare = async (event) => {
        const origin = window?.location?.origin || '';
        
        // Build minimal deep link with only event ID (no title, date, or location)
        const deepLink = buildDeepLink({ origin, eventId: event.event_id });

        try {
            const ok = await shareDeepLink({ title: event.title, text: event.description, url: deepLink });
            if (!ok) console.log('Share fallback engaged');
        } catch (err) {
            console.error('Error sharing:', err);
        }

        if (onShare) onShare(event);
    };

    if (loading) {
        return (
            <div className="event-list-grid">
                <div className="event-list-grid__loading">
                    <div className="spinner-border text-primary" role="status">
                        <span className="sr-only">Loading...</span>
                    </div>
                    <p>Loading events...</p>
                </div>
            </div>
        );
    }

    if (!events || events.length === 0) {
        return (
            <div className="event-list-grid">
                <div className="event-list-grid__empty">
                    <i className="fas fa-calendar-times"></i>
                    <h4>No Events Found</h4>
                    <p>Try adjusting your filters to see more events.</p>
                </div>
            </div>
        );
    }

    return (
        <div className="event-list-grid">
            <div className="event-list-grid__container">
                {events.map((event, index) => (
                    <div key={event.event_id || index} className="event-list-grid__item">
                        <EventCard event={event} onShare={handleShare} />
                    </div>
                ))}
            </div>
        </div>
    );
};

EventListGrid.propTypes = {
    events: PropTypes.arrayOf(PropTypes.object),
    loading: PropTypes.bool,
    onShare: PropTypes.func
};

EventListGrid.defaultProps = {
    events: [],
    loading: false
};

export default EventListGrid;

